import {ClearMessagesAction, FrameActionEnum, PostMessageAction, PostSuspendedAction} from './FrameAction';

/**
 * Nastaví pozastavení zpracování zpráv ve frontě.
 *
 * @param suspended - Zda je zpracování pozastaveno.
 * @returns Akce.
 */
export const setPostSuspended = (suspended: boolean): PostSuspendedAction => ({
    type: FrameActionEnum.SET_POST_SUSPENDED,
    suspended,
});

/**
 * Zařadí zprávu pro frame do fronty.
 *
 * @param message - Message pro poslání.
 * @returns Akce.
 */
export const postMessage = <T>(message: T): PostMessageAction<T> => ({
    type: FrameActionEnum.POST_MESSAGE,
    message,
});

/**
 * Smaže všechny zprávy ve frontě pro frame.
 *
 * @returns Akce.
 */
export const clearMessages = (): ClearMessagesAction => ({
    type: FrameActionEnum.CLEAR_MESSAGES,
});
